import { useMemo } from 'react'
import isBefore from 'date-fns/isBefore'
import addDays from 'date-fns/addDays'
import differenceInDays from 'date-fns/differenceInDays'

const useIsBeforeOrder = (
  now: Date,
  orderStartDateTime: Date,
  isAfterLastOrder: boolean,
  nextBusinessDate: Date
): boolean => {
  return useMemo(() => {
    const diff = differenceInDays(nextBusinessDate, now)
    return isBefore(now, isAfterLastOrder ? addDays(orderStartDateTime, diff + 1) : orderStartDateTime)
  }, [now, orderStartDateTime, isAfterLastOrder, nextBusinessDate])
}

export default useIsBeforeOrder
